import { FC, useId } from 'react';

import { EntityTeamItem, legalRoleTransitionStatus } from '@/api/entity/types';
import InfoIcon from '@/assets/svg/ui-elements/alert-circle-filled-yellow.svg';
import { theme, Tooltip, Typography, VisuallyHidden } from '@/shared/design-system';

import { DirectorCell, DirectorHintTrigger } from './user-details.styled';

export const DIRECTOR_PENDING_TOOLTIP =
  'A new Director has been added to the team. This change is being reviewed by Gamma. Until approval, the user is not considered a Director.';
export const DIRECTOR_REMOVAL_PENDING_TOOLTIP =
  'You have submitted a change in the Director status for this user. The change is being reviewed by Gamma Prime. Until approval, this user is considered a Director.';

const ICON_SIZE = 16;

export const MemberDirectorCell: FC<{ data: EntityTeamItem }> = ({ data }) => {
  const descriptionId = `member-director-hint-${useId()}`;

  const isPromotionPending =
    data.legalRoleTransitionStatus === legalRoleTransitionStatus.FromTeamMemberToDirectorPending;
  const isRemovalPending =
    data.legalRoleTransitionStatus === legalRoleTransitionStatus.FromDirectorToTeamMemberPending;
  const isDirectorLegalRole =
    data.legalRoleTransitionStatus === legalRoleTransitionStatus.DirectorApproved ||
    data.legalRoleTransitionStatus === legalRoleTransitionStatus.DirectorPending;

  const isDirector =
    data.entityInvitationId === null ? isRemovalPending || isDirectorLegalRole : data.isDirector;

  const hint = isPromotionPending
    ? DIRECTOR_PENDING_TOOLTIP
    : isRemovalPending
      ? DIRECTOR_REMOVAL_PENDING_TOOLTIP
      : null;

  return (
    <DirectorCell>
      <Typography variant="body3" color={theme.colors.text.primary}>
        {isDirector ? 'Yes' : 'No'}
      </Typography>

      {hint && (
        <>
          <Tooltip title={hint} side="top">
            <DirectorHintTrigger role="term" tabIndex={0} aria-describedby={descriptionId}>
              <InfoIcon width={ICON_SIZE} height={ICON_SIZE} />
            </DirectorHintTrigger>
          </Tooltip>
          <VisuallyHidden id={descriptionId}>{hint}</VisuallyHidden>
        </>
      )}
    </DirectorCell>
  );
};
